module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.a4d31128b633bc0b1cc1.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/material-design-iconic-font/dist/fonts/Material-Design-Iconic-Font.woff2?v=2.2.0
// module id = ../../../../material-design-iconic-font/dist/fonts/Material-Design-Iconic-Font.woff2?v=2.2.0
// module chunks = 2